export default __webpack_public_path__ + "static/media/oeste_logo.dd8d87b9.jpg";